<template>
    <dx-popup 
        :ref="referencia" 
        :width="larguraComputed" 
        :height="altura" 
        :title="!icone ? titulo : ''" 
        :showTitle="mostrarTitulo" 
        :visible="visible" 
        :showCloseButton="mostrarBotaoFechar" 
        :animation="animation" 
        :onInitialized="onInitialized" 
        :onShowing="onShowing" 
        :onShown="onShownComponente" 
        :onHiding="onHiding"
        :hideOnOutsideClick="fecharAoClicarFora" 
        :container="pai"
        :position="position"
        :resizeEnabled="resizeEnabled"
        :onResizeEnd="onResizeEnd"
        :fullScreen="telaCheia"
        :dragEnabled="dragEnabled && !telaCheia"
        :maxHeight="maxHeight"
        :maxWidth="maxWidth"
        :deferRendering="deferRendering"
        :onHidden="onHidden"
        :shading="destaque"
    >
        <dx-scroll-view
            showScrollbar="onHover"
            height="100%"
            :class="modalClass"
            ref="scrollView"
            v-if="showScroll"
        >
            <slot></slot>
        </dx-scroll-view>
        <slot v-else></slot>

        <dx-toolbar-item v-if="icone"
            location="before"
            :template="`<div class='dx-form-group-caption titulo-grupo'><i class='${icone}'></i><div class='titulo'>${titulo}</div></div>`"
        >
        </dx-toolbar-item>

        <dx-toolbar-item v-for="(botao, index) in botoesAdicionais" :key="index"
            location="after"
            widget= "dxButton"
            :options="botao"
        >
        </dx-toolbar-item>

        <dx-toolbar-item v-for="(botao, index) in botoes" :key="index"
            :widget="botao.widget || (botao.options ? 'dxButton' : undefined)" 
            :toolbar="botao.toolbar || 'bottom'"
            :location="botao.location || 'after'"
            :locateInMenu="botao.locateInMenu || 'never'"
            :visible="botao.visible !== undefined ? botao.visible : true"
            :disabled="botao.disabled"
            :template="botao.template"
            :text="botao.text"
            :options="botao.options" >
        </dx-toolbar-item>       
        
    </dx-popup>
</template>

<script>
    import { DxPopup, DxToolbar, DxButton, DxScrollView } from "devextreme-vue"
    import { DxTextBox, DxDateBox, DxNumberBox, DxSelectBox, DxCheckBox } from 'devextreme-vue'
    import { DxToolbarItem } from 'devextreme-vue/popup'
    import { moverParaNovoParent } from '@/funcoes/dom.js';

    import { mapGetters } from "vuex";
    
    export default {
        
        props: {
            destaque: {
                type: Boolean,
                default: true
            },
            modalClass: {
                type: String,
                default: null
            },
            enterAsTab: {
                type: Boolean,
                default: true
            },
            largura: {
                type: [Number, String, Function],
                default: "auto"
            },            
            altura: {
                type: [Number, String, Function],
                default: "auto"
            },
            botoes: {
                type: Array,
                default: () => ([])
            },
            titulo: {
                type: String,
                default: ""
            },
            mostrarTitulo: {
                type: Boolean,
                default: true
            },
            mostrarBotaoFechar: {
                type: Boolean,
                default: true
            },
            idForm: {
                type: String,
                default: "form-modal"
            },
            onShown: {
                type: Function,
                default: () => ({})
            },
            visivel: {
                type: Boolean,
                default: false
            },
            fecharAoClicarFora: {
                type: Boolean,
                default: false
            },
            referencia: {
                type: String,
                default: "popup"
            },
            pai: {
                type: String,
                default: undefined
            },
            moverDOM: { //é complementado com o de cima.. eu uso isso (richard)
                type: Boolean,
                default: false
            },
            posicao: {
                type: Object,
                //default: () => { return { at: 'center', of: _this.pai || 'window' } }
            },
            resizeEnabled: {
                type: Boolean,
                default: false
            },
            onResizeEnd: {
                type: Function,
                default: () => ({ })
            },
            telaCheia: {
                type: Boolean,
                default: false
            },
            icone: {
                type: String,
                default: undefined
            },
            showScroll: {
                type: Boolean,
                default: false
            },
            dragEnabled: {
                type: Boolean,
                default: true
            },
            maxHeight: {
                type: [Number, String, Function],
                default: 'unset'
            },
            maxWidth: {
                type: [Number, String, Function],
                default: 'unset'
            },
            deferRendering: {
                type: Boolean,
                default: true
            },
            onHiding: {
                type: Function,
                default: undefined
            },
            botoesAdicionais: {
                type: Array,
                default: () => ([])
            },
            animacao: {
                type: Object,
                default: () => (null)
            }
        },
        components: {
            DxPopup, DxToolbar, DxButton, DxScrollView, DxToolbarItem
        },
        data() {
            return {
                animation: this.animacao || this.$vistra.popupAnimation
            }
        },
        created() {
            return 
            //tags: tab enter
            if (this.enterAsTab) {
                
                var processaEnter = {
                    options: {
                        onInitialized: function (e) {
                            e.component.on("enterKey", function (args) {
                                if (args.event.which == 13) {
                                    args.event.preventDefault();
                                    var inputs = [...document.querySelectorAll('[tabindex]')];
                                    if (inputs.length) {
                                        var i = inputs.indexOf(document.activeElement) + 1;
                                        if (i >= inputs.length)
                                            return;
                                        inputs[i].focus();
                                    }
                                }
                            });
                        }
                    }
                }

                DxTextBox.defaultOptions(processaEnter)
                DxDateBox.defaultOptions(processaEnter)
                DxNumberBox.defaultOptions(processaEnter)
                DxSelectBox.defaultOptions(processaEnter)
                DxCheckBox.defaultOptions(processaEnter)
            }
        },
        mounted() {        
            //scroll
            //console.log('scroll:', !this.showScroll && this.$refs.scrollView)
            if (!this.showScroll && this.$refs.scrollView) {
                this.$refs.scrollView.instance.option('showScrollbar', 'never');
                this.$refs.scrollView.instance.option('disabled', true);
            }
        },
        methods: {
            // Outros componentes chamam essa função.
            hide() {
               this.$refs.popup.instance.hide();
            },
            onInitialized() {
                //quando a div de fora está "dysplay none", o modal nao executa.. daí é necessário mudar ele de lugar na inicialização para que funcione corretamente
                if (this.moverDOM && this.pai) {
                    moverParaNovoParent(document.querySelector(this.pai), this.$refs[this.referencia].$el)
                }
            },
            onShowing() {
            },
            onShownComponente() {
                this.selecionaPrimeiro()

                if (this.onShown)
                    this.onShown();
            },
            selecionaPrimeiro() {
                var inputs = [];
                document.querySelectorAll('.primeiro-input').forEach(e => { //seleciona tudo que
                   e.querySelectorAll('input:not([type="hidden"]):not([disabled])') //todos input 'nao hidden' e 'nao disabled'
                    .forEach(i => {
                       if (i.offsetParent != null) //separa 'display: none'
                            inputs.push(i)
                    })
                })

                if (inputs.length) {
                    inputs[0].focus();
                    inputs[0].select();
                }

                document.querySelectorAll('input').forEach(e => { //remove auto complete
                    e.autocomplete = "nope" //qualter texto inválido pq off nem sempre funciona
                })
            },
            onHidden() {
                this.$emit("resetarVisibilidade");
            }
        },
        watch: {
            onContentResized() {
                this.$refs[this.referencia]?.instance?.repaint()
            },
        },
        computed: {
            larguraComputed() {
                if(isNaN(this.largura))
                    return this.largura                

                if(window.innerWidth > this.largura)
                    return this.largura
                
                return window.innerWidth
            },
            ...mapGetters(["onContentResized"]), //eventos
            visible: {
                get: function() {
                    return this.visivel
                },
                set: function(value) {
                    if (value == false)
                        this.$emit("resetarVisibilidade");
                }
            },
            position() {
                let posicaoAux = this.posicao
                if (!posicaoAux) //se não mandou via props, cria padrão
                    return { at: 'center', of: this.pai || 'window' }
                if (!posicaoAux.at) //se não foi enviado via props o pai, coloca o pai (se existir) senão a janela
                    posicaoAux.at = this.pai || 'window'
                return posicaoAux
            }
        }
    }
</script>



